import type { JSX } from 'react';

import { WerklijnContextMenuDetails } from '@/components/contextMenu/mwdContextMenu/types';
import { ClaimEigenschappen } from '@/queries/mutaties/opdrachten';

export type ClaimFormType = {
  vertrek: HTMLInputElement;
  aankomst: HTMLInputElement;
  beginDatum: HTMLSelectElement;
  eindDatum: HTMLSelectElement;
  beginTijd: HTMLInputElement;
  eindTijd: HTMLInputElement;
  claimsoort: HTMLSelectElement;
  materieelsoortCode: HTMLInputElement;
  materieelAanduiding: HTMLInputElement;
  toelichting: HTMLTextAreaElement;
  bijzonderheidscode: HTMLInputElement;
};

export type ClaimBetrokkenWerklijnType = {
  id: string;
  versie: number;
};

export type FieldErrorsType = { [key: string]: string };

export type CreateClaimFormHelperType = {
  beginDatum: string;
  beginTijd: string;
  eindDatum: string;
  eindTijd: string;
};

export type ClaimPostStateType = CreateClaimFormHelperType & {
  naInzetId: string | null;
  inzetId: string | null;
  betrokkenWerklijn: ClaimBetrokkenWerklijnType;
  eigenschappen: ClaimEigenschappen;
  fieldErrors: FieldErrorsType;
  claimType: 'MC' | 'RC';
  isUpdate: boolean;
};

// stricly named 'type', else the useReducer won't be typed to take action
export type ClaimReducerActionType = {
  type: 'updateDetails' | 'updateDateTime' | 'update' | 'reset' | 'invalidate';
  field?: keyof ClaimPostStateType | keyof ClaimEigenschappen;
  value?: string | WerklijnContextMenuDetails;
  isUpdate?: boolean;
};

export const defaultBetrokkenWerklijn = (werklijnId: string, versie: number) =>
  structuredClone<{ betrokkenWerklijn: ClaimBetrokkenWerklijnType }>({
    betrokkenWerklijn: {
      id: werklijnId,
      versie,
    },
  });

export const defaultClaimEigenschappen = (defaultValues?: Partial<ClaimEigenschappen>) =>
  structuredClone<ClaimEigenschappen>({
    materieelsoortCode: '',
    materieelAanduiding: '',
    vertrek: '',
    aankomst: '',
    beginDatumTijd: '',
    eindDatumTijd: '',
    claimsoort: '.', // empty defaults to a point
    toelichting: '',
    bijzonderheidscode: '',
    ...defaultValues,
  });

export const defaultState = (werklijnId: string, versie: number): ClaimPostStateType => {
  return structuredClone<ClaimPostStateType>({
    ...defaultBetrokkenWerklijn(werklijnId, versie),
    eigenschappen: defaultClaimEigenschappen(),
    beginDatum: '',
    beginTijd: '',
    eindDatum: '',
    eindTijd: '',
    fieldErrors: {},
    claimType: 'RC',
    inzetId: null,
    naInzetId: null,
    isUpdate: false,
  });
};

export type LabelType = {
  label: JSX.Element | string;
  value: string;
};
